module.exports = __webpack_public_path__ + "static/media/ic_wcag_reset.8a62b528.svg";